export default () => {
  let gtmLoaded = false;

  function initGTM() {
    if (gtmLoaded) return;
    gtmLoaded = true;

    // Remove all event listeners once GTM is loaded
    window.removeEventListener('click', initGTM);
    window.removeEventListener('scroll', initGTM);
    window.removeEventListener('touchstart', initGTM);
    window.removeEventListener('touchend', initGTM);
    window.removeEventListener('touchmove', initGTM);
    window.removeEventListener('pointerdown', initGTM);
    window.removeEventListener('pointerup', initGTM);
    document.removeEventListener('visibilitychange', initGTM);

    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => loadGTM());
    } else {
      setTimeout(loadGTM, 100);
    }
  }

  function setupEventListeners() {
    // Add event listeners for user interactions (desktop and mobile)
    window.addEventListener('click', initGTM, { once: true, passive: true });
    window.addEventListener('scroll', initGTM, { once: true, passive: true });
    window.addEventListener('touchstart', initGTM, { once: true, passive: true });
    window.addEventListener('touchend', initGTM, { once: true, passive: true });
    window.addEventListener('touchmove', initGTM, { once: true, passive: true });
    window.addEventListener('pointerdown', initGTM, { once: true, passive: true });
    window.addEventListener('pointerup', initGTM, { once: true, passive: true });
    document.addEventListener('visibilitychange', initGTM, { once: true });
  }

  // Ensure DOM is ready before adding listeners
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEventListeners);
  } else {
    setupEventListeners();
  }

  setTimeout(() => {
    initGTM();
  }, 5000); // Reduced to 5 seconds for testing

  function loadGTM() {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-TMV33V');
  }
};
